import { z } from "zod";

// Regla de vigencia (decisión humana 2026-09-29): la fecha de fin no puede ser
// anterior a la de inicio — igual se admite — y solo se valida cuando las dos
// están cargadas. La API rechaza lo mismo con `400 INVALID_REQUEST`, campo
// `validUntil` y este mismo texto, así que el error de cliente y el rechazo
// del servidor leen igual bajo "Vigente hasta". Compartida por los esquemas de
// Beneficios, Recompensas, Ofertas y Promociones.
export const VALIDITY_RANGE_MESSAGE =
  "La fecha de fin de vigencia no puede ser anterior a la de inicio.";

/** Llamar desde el `superRefine` del formulario. Las fechas son `YYYY-MM-DD`
 * (el valor de `<input type="date">`), así que comparar los strings ordena
 * igual que comparar las fechas de calendario, sin pasar por `Date` ni husos. */
export function requireValidityOrder(
  values: { validFrom: string; validUntil: string },
  ctx: z.RefinementCtx,
): void {
  const { validFrom, validUntil } = values;
  if (validFrom && validUntil && validUntil < validFrom) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["validUntil"],
      message: VALIDITY_RANGE_MESSAGE,
    });
  }
}
